import Footer from "../Components/Footer/Footer";
import Navigationbar from "../Components/Navbar/Navbar";
import ProjectContainer from "../Components/ProjectContainer/ProjectContainer";
import ProjectsTitle from "../Components/ProjectsTitle/ProjectsTitle";
import Spacer from "../Components/Spacer/Spacer";
// import ParallaxBanner from "../Components/parallaxBanner/ParallaxBanner";

function Projects() {
  return (
    <>
      <Navigationbar />
      <Spacer />
      {/* <ParallaxBanner /> */}
      <ProjectsTitle />
      <ProjectContainer />
      <Footer />
    </>
  );
}

export default Projects;
